<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype" style="line-height: 48px;border: none">
          <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select @change="searchData" v-model="public_id" placeholder="请选择">
              <el-option
                v-for="item in weChatOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content common-search-formtype" style="padding: 0;border: none">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="输入搜索：">
              <el-input v-model.trim="formInlineTmp.keywords" placeholder="请输入活动名称" clearable ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">活动类型列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addOfflineAcivityAction" class="add-btn btn-right" style="float: right;">新建</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <el-table-column
          label="活动名称">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.activity_name }}</p>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.activity_name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="微信公众号"
          prop="wechat_name"
          width="">
        </el-table-column> -->
        <el-table-column
          label="扫码次数/关注人数/参与人数"
          width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.scan_num }}</span>
            /<span>{{ scope.row.follow_num }}</span>
            <span v-if="scope.row.replay_type === 3">
              /{{ scope.row.canyu_num }}
            </span>
            <span v-else>/--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="qrcode_num"
          label="申请次数"
          width="">
        </el-table-column>
        <el-table-column
          label="回复类型"
          width="">
           <template slot-scope="scope">
            <div v-if="scope.row.replay_type === 0">不回复</div>
            <div v-if="scope.row.replay_type === 1">文本</div>
            <div v-if="scope.row.replay_type === 2">图片</div>
            <div v-if="scope.row.replay_type === 3" @click="toMicroPage(scope.row.replay_scene_id)" style="color: #1980FF;cursor: pointer">微页面</div>
            <div v-if="scope.row.replay_type === 4">外部页</div>
            <div v-if="scope.row.replay_type === 5">大转盘</div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="135">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" @click="pushToInfoManage(scope.row.id)">
              编辑
            </div>
            <div class="op-link" @click="pushToInfoStatics(scope.row.id, scope.row.public_id, scope.row.activity_name)">
              申请记录
            </div>
            <div class="op-link" @click="deleteActivity(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 二维码 -->
      <el-dialog class="cellDialog" title="二维码" :visible.sync="QRViewDialog" width="600px">
        <img :src="QRImage" class="qrcode-image">
      </el-dialog>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getWeChatActivityList, deleteWeChatActivity, getCustomerSourceListForWepage, getWechatPublicListForNode } from '@/api/customer.js'
export default {
  name: 'offlineActivityList',
  data () {
    return {
      modelId: '',
      weChatOptions: [],
      loading: true,
      QRViewDialog: false,
      QRImage: '',
      public_id: 0,
      formInlineTmp: {},
      formInline: {
        activity_name: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isSwitchClick: 1
    }
  },
  methods: {
    searchData(val) {
      for (let one of this.weChatOptions) {
        if (one.id === val) {
          this.modelId = one.model_id
        }
      }
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    // 跳转到微页面统计
    toMicroPage(id) {
      router.push('/home/micro-page-data?id=' + id)
    },
    addOfflineAcivityAction() {
      if (this.public_id === 0) {
        _g.toastMsg('error', '请选择具体公众号')
        return
      }
      console.log('this.public_id', this.public_id)
      router.push({ path: '/home/add-offline-activity', query: { public_id: this.public_id, modelId: this.modelId } })
    },
    addMemberInterestAction() {
      router.push('/home/add-member-interest')
    },
    pushToInfoManage(Id) {
      if (this.public_id === 0) {
        _g.toastMsg('error', '请选择具体公众号')
        return
      }
      router.push({path: '/home/edit-offline-activity', query: { id: Id, modelId: this.modelId, public_id: this.public_id }})
    },
    pushToInfoStatics(Id, public_id, activity_name) {
      router.push({path: '/home/activity-count-list', query: { id: Id, public_id: public_id, activity_name: activity_name }})
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getWeChatActivityList(this.page, this.public_id, this.formInline).then(res => {
        this.totalCount = res.data.data.total
        this.tableData = res.data.data.list
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    deleteActivity(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWeChatActivity(id).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            if (this.tableData.length === 1 && this.page !== 1) {
              this.page = this.page - 1
              this.getData()
            } else {
              this.getData()
            }
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    loadWechatList() {
      getWechatPublicListForNode('1').then(res => {
        for (let item of res.data.data.list) {
          this.weChatOptions.push({
            id: item.id,
            name: item.nick_name,
            model_id: item.model_id
          })
          if (item.is_default === 1) {
            this.public_id = item.id
            this.modelId = item.model_id
          }
        }
        this.getData()
      })
    }
  },
  created() {
    this.loadWechatList()
  },
  components: {
  }
}
</script>

<style scoped>
.name-wrapper {
  width: 100px;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}
</style>
